import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { forkJoin } from 'rxjs';
import { SyllabusService } from '@examdojo/category/v2';
import { mapToVoid } from '@examdojo/core/rxjs';
import { AdminUserService } from './admin-user.service';

export const adminsUsersListResolver: ResolveFn<void> = () => {
  const adminUserService = inject(AdminUserService);
  const syllabusService = inject(SyllabusService);

  return forkJoin([syllabusService.fetchSyllabuses(), adminUserService.fetchAll()]).pipe(mapToVoid());
};
